import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api, unwrap } from "@/lib/api";

/**
 * Floating WhatsApp launcher — pure deep-link to wa.me (NO API integration).
 * The number is read from admin Settings (`whatsapp_number`). If it's empty,
 * the button hides itself. Editing the number in /admin/settings updates this
 * instantly with no redeploy.
 */
export default function WhatsAppFAB({ message = "Hi! I'd like to know more about Ever Clean Home.", label = "WhatsApp" }) {
  const [number, setNumber] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/public/settings")
      .then((r) => { if (!cancelled) setNumber((unwrap(r) || {}).whatsapp_number || ""); })
      .catch(() => { if (!cancelled) setNumber(""); });
    return () => { cancelled = true; };
  }, []);

  const digits = (number || "").replace(/[^0-9]/g, "");
  if (!digits) return null;

  const url = `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-30 group"
      data-testid="whatsapp-fab"
    >
      <span className="flex items-center gap-2 bg-[#25D366] text-white pl-3.5 pr-4 py-3 rounded-full shadow-lg shadow-[#25D366]/30 hover:shadow-xl hover:scale-[1.04] active:scale-[0.98] transition-all">
        <MessageCircle className="w-5 h-5" fill="currentColor" strokeWidth={0} />
        <span className="hidden sm:inline text-sm font-semibold">{label}</span>
      </span>
    </a>
  );
}
